import React from "react";
import { Card, Row, Col, Tag } from "antd";

const Legend = ({ showCompetitors, showPartners }) => {
  const hasExtra = showCompetitors || showPartners;
  const colSize = hasExtra ? 4 : 6;
  
  return (
    <Card 
      size="small" 
      style={{ marginTop: '8px' }}
      bodyStyle={{ padding: '8px' }}
    >
      <Row gutter={[8, 8]}>
        <Col xs={12} sm={colSize} md={colSize}>
          <Tag color="red" style={{ width: '100%', textAlign: 'center' }}>Disattivati</Tag>
        </Col>
        <Col xs={12} sm={colSize} md={colSize}>
          <Tag color="blue" style={{ width: '100%', textAlign: 'center' }}>Attivi - Free</Tag>
        </Col>
        <Col xs={12} sm={colSize} md={colSize}>
          <Tag color="green" style={{ width: '100%', textAlign: 'center' }}>Attivi - Production</Tag>
        </Col>
        <Col xs={12} sm={colSize} md={colSize}>
          <Tag color="purple" style={{ width: '100%', textAlign: 'center' }}>Attivi - Demo</Tag>
        </Col>
        {showCompetitors && (
          <Col xs={12} sm={colSize} md={colSize}>
            <Tag style={{ width: '100%', textAlign: 'center', backgroundColor: 'black', color: 'white', border: 'none' }}>
              ⚠️ Competitor
            </Tag>
          </Col>
        )}
        {showPartners && (
          <Col xs={12} sm={colSize} md={colSize}>
            <Tag style={{ 
              width: '100%', 
              textAlign: 'center',
              background: 'linear-gradient(to right, red, orange, yellow, green, blue, indigo, violet)',
              color: 'white',
              border: 'none',
              fontWeight: 'bold'
            }}>
              🤝 Partner
            </Tag>
          </Col>
        )}
      </Row>
    </Card>
  );
};

export default Legend; 